import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

import { Form } from 'react-bulma-components';
import InputMask from 'react-input-mask';

const { Field, Label } = Form;

import './input-totp.scss';

const CustomTotpInputV2 = (props) => {
    const { label, mask, value, onChange, onKeyDown, disabled, autoFocus } = props;

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef?.current) {
            inputRef.current.focus();
        }
    }, [inputRef]);

    return (
        <Field className='totp-input__container'>
            {label && (
                <Label id={label} className='totp-input__label'>
                    {label}
                </Label>
            )}
            <div className='totp-input__wrapper'>
                <InputMask
                    className='totp-input__field'
                    alwaysShowMask
                    maskPlaceholder='_'
                    mask={mask || '999 999'}
                    ref={inputRef}
                    value={value}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    disabled={disabled}
                    autoFocus={autoFocus}
                />
            </div>
        </Field>
    );
};

export default CustomTotpInputV2;

CustomTotpInputV2.propTypes = {
    label: PropTypes.string,
    mask: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool
};
